"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * {@code Pagination} converter.
 *
 * @author Radek Beran
 */


var PaginationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PaginationConverter, _DataObjectConverter_);

  function PaginationConverter() {
    _classCallCheck(this, PaginationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PaginationConverter).apply(this, arguments));
  }

  return PaginationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PaginationConverter = PaginationConverter;